import React, { useEffect, useState } from "react";
import { useInView } from 'react-intersection-observer';
import CountUp from "react-countup";
import { Smile, Home, Package, ClipboardList, HandCoins, Boxes, BookOpen, HeartHandshake, Plane, Users, Clock, Banknote, Stethoscope, Factory, ShoppingCart, Book, } from 'lucide-react';
import WhyChooseUs from "./WhyChooseUs";
import analysisImage from '../assests/images/analysis.jpg';
import header from "../assests/images/about-1.jpg";
import business from "../assests/images/business-central-icon.png";
import dynamicsicon from "../assests/images/office365_icon.png";
import erpnextIcon from "../assests/images/Erpnext-icon.jpg";
import powerbiIcon from "../assests/images/powerBI_icon.png";
import crm from "../assests/images/crm-icon.png";
import azure from "../assests/images/azure-icon.png";

const ProductsPage = () => {
  const [statsVisible, setStatsVisible] = useState(false);
  const { ref: statsRef, inView: statsInView } = useInView({ threshold: 0.3, triggerOnce: true });
  const { ref: industriesRef, inView: industriesInView } = useInView({ threshold: 0.2, triggerOnce: true });
  const getGridStyle = () => {
    const width = window.innerWidth;

    if (width < 576) {
      return {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '1.5rem',
      };
    } else if (width >= 576 && width < 992) {
      return {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '2rem',
      };
    } else {
      return {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '2rem',
      };
    }
  };

  const industries = [
    {
      name: 'Finance and Accounting',
      background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174) 100%)',
      icon: <Banknote style={{ width: 40, height: 40, color: '#024A59' }} />,
      text: 'Managing financial transactions, general ledger, budgeting and compliance.'
    },
    {
      name: 'Supply chain and Inventory',
      background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
      icon: <Package style={{ width: 40, height: 40, color: '#024A59' }} />,
      text: 'Optimizing procurement, inventory control, and logistics.'
    },
    {
      name: 'HR & Payroll',
      background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174) 100%)',
      icon: <Users style={{ width: 40, height: 40, color: '#FFA916' }} />,
      text: 'Automate HR, payroll, benefits & performance tracking.',
    },
    {
      name: 'Sacco & Microfinance',
      background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
      icon: <HandCoins style={{ width: 40, height: 40, color: '#FFA916' }} />,
      text: 'Manage member savings, loans & compliance.',
    },
    {
      name: 'Health',
      background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174)  100%)',
      icon: <Stethoscope style={{ width: 40, height: 40, color: '#FFA916' }} />,
      text: 'Streamlining patient data and healthcare operations.'
    },
    {
      name: 'Education',
      background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
      icon: <Book style={{ width: 40, height: 40, color: '#024A59' }} />,
      text: 'Managing student admissions, academic records, fee collection, and academic performance tracking.'
    },
    {
      name: 'Point of Sale',
      background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174)  100%)',
      icon: <ShoppingCart style={{ width: 40, height: 40, color: '#024A59' }} />,
      text: 'Managing sales, inventory, and customer transactions.'
    },
    {
      name: 'Tours & Travel',
      background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
      icon: <Plane style={{ width: 40, height: 40, color: '#FFA916' }} />,
      text: 'Booking, itinerary planning, and customer experience optimization.'
    },
    {
      name: 'Property & Real Estate',
      background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174)  100%)',
      icon: <Home style={{ width: 40, height: 40, color: '#024A59' }} />,
      text: 'Managing properties, leases, tenants, and real estate portfolios.'
    },
    {
      name: 'Manufacturing',
      background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
      icon: <Factory style={{ width: 40, height: 40, color: '#FFA916' }} />,
      text: 'Enhancing production and resource management.'
    },
    {
      name: 'NGO',
      background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174)  100%)',
      icon: <Users style={{ width: 40, height: 40, color: '#024A59' }} />,
      text: 'Managing donor funding, project monitoring, and compliance.'
    },
    {
      name: 'Projects',
      background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
      icon: <ClipboardList style={{ width: 40, height: 40, color: '#FFA916' }} />,
      text: 'Planning, tracking and managing multiple project deliverables.'
    }
  ];

  useEffect(() => {
    if (statsInView) setStatsVisible(true);
  }, [statsInView]);

  return (
    <div style={{ backgroundColor: '#f8fafc' }}>

      {/* Page Header */}
      <div
        className="container-fluid page-header py-1 mb-2 wow fadeIn"
        data-wow-delay="0.1s"
        style={{
          background: `linear-gradient(rgba(2, 74, 89, 0.7), rgba(2, 74, 89, 0.7)), url(${header})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "300px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <div className="container text-center">
          <h1 className="display-4 text-white mb-3 animated slideInDown">
            Our Products
          </h1>
          <nav aria-label="breadcrumb" className="animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item">
                <a className="text-white" href="/">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item">
                <a className="text-white" href="/">
                  Pages
                </a>
              </li>
              <li className="breadcrumb-item text-yellow active" style={{ color: "#FFA916" }} aria-current="page">
                Products
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Products Section */}
      <div style={{ padding: '2rem 0', backgroundColor: '#fff', width: '100%' }}>
      <div style={{ margin: '0 auto', padding: '0 1rem', maxWidth: '1320px' }}>
        <div
          style={{
            maxWidth: '600px',
            margin: '0 auto',
            marginBottom: '1.5rem',
            textAlign: 'center',
          }}
        >
          <h1 style={{ color: '#024A59', fontWeight: 600, fontSize: '1.2rem' }}>
            Cutting-edge solutions designed to empower your business with seamless integrations
            and superior performances.
          </h1>
        </div>

        <div style={getGridStyle()}>
          {[
            {
              img: dynamicsicon,
              title: 'Microsoft Office 365',
              text: 'Enhance productivity and collaboration with powerful business tools.',
            },
            {
              img: business,
              title: 'Dynamics 365 Business Central/NAV',
              text: 'Streamline operations and drive growth with all-in-one management.',
            },
            {
              img: crm,
              title: 'Microsoft Dynamics CRM',
              text: 'Build strong customer relationships with intuitive CRM tools.',
            },
            {
              img: azure,
              title: 'Microsoft Azure',
              text: 'Leverage cloud power for unparalleled scalability and performance.',
            },
            {
              img: erpnextIcon,
              title: 'ERPNext',
              text: 'A powerful open-source ERP system for modern businesses.',
            },
            {
              img: powerbiIcon,
              title: 'Microsoft Power BI',
              text: 'Transform your data into insightful visual reports and dashboards.',
            },
          ].map((product, index) => (
            <div
              key={index}
              style={{
                padding: '1.5rem',
                border: '1px solid #e0e0e0',
                borderRadius: '10px',
                textAlign: 'center',
                boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
                backgroundColor: '#fff',
              }}
            >
              <div style={{ marginBottom: '1rem' }}>
                <img
                  src={product.img}
                  alt={product.title}
                  style={{ width: '60px', height: '60px', objectFit: 'contain' }}
                />
              </div>
              <h5 style={{ fontWeight: '600', marginBottom: '0.5rem' }}>{product.title}</h5>
              <p style={{ color: '#666', fontSize: '0.95rem' }}>{product.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>


      {/* Stats Section */}
      <div
        ref={statsRef}
        style={{
          backgroundImage: `url(${analysisImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '2rem 1rem',
          color: 'white',
          position: 'relative',
        }}
      >
        {/* Optional overlay for better readability */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(2, 74, 89, 0.85)', // optional dark overlay
          zIndex: 0,
        }} />

        <h5 style={{
          textAlign: 'center',
          color: 'white',
          marginBottom: '2rem',
          position: 'relative',
          zIndex: 1
        }}>
          Empowering your business to reach new heights.
        </h5>

        <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '2rem',
            textAlign: 'center'
          }}>
            {[
              { number: 100, title: "Happy Clients", icon: <Smile size={40} color="#FFA916" /> },
              { number: 20, title: "Team Members", icon: <Users size={40} color="#FFA916" /> },
              { number: 24, title: "Support Hours", icon: <Clock size={40} color="#FFA916" /> }
            ].map((stat, index) => (
              <div key={index} style={{
                opacity: statsVisible ? 1 : 0,
                transform: statsVisible ? 'translateY(0)' : 'translateY(30px)',
                transition: `all 0.6s ease ${index * 0.2}s`,
                background: 'rgba(255, 255, 255, 0.15)', // semi-transparent white
                borderRadius: '16px',
                padding: '2rem',
                backdropFilter: 'blur(6px)', // optional glass effect
              }}>
                <div style={{
                  background: 'rgba(255, 169, 22, 0.1)',
                  width: '70px',
                  height: '70px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem'
                }}>
                  {stat.icon}
                </div>
                <h2 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#FFA916', marginBottom: '0.5rem' }}>
                  {statsVisible ? <CountUp end={stat.number} duration={2.5} /> : stat.number}
                  {stat.title === 'Projects Completed' && '%'}
                  {['Happy Clients'].includes(stat.title) && '%'}
                  {['Team Members'].includes(stat.title) && '+'}
                </h2>
                <p style={{ fontSize: '1.1rem', margin: 0 }}>{stat.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Solution Section */}
      <div ref={industriesRef} style={{ padding: '2rem 2rem' }}>
        <div style={{ maxWidth: '85%', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: 700,
              color: '#1e293b',
              marginBottom: '1rem'
            }}>
              Our Solutions
            </h2>
            <p style={{ color: '#64748b', fontSize: '1.1rem' }}>
              Tailored solutions for diverse industry needs
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '2rem',
            padding: '1rem'
          }}>
            {industries.map((industry, index) => (
              <div key={index} style={{
                opacity: industriesInView ? 1 : 0,
                transform: industriesInView ? 'translateY(0)' : 'translateY(30px)',
                transition: `all 0.6s ease ${index * 0.2}s`
              }}>
                <div style={{
                  background: industry.background,
                  borderRadius: '16px',
                  padding: '2rem',
                  height: '100%',
                  textAlign: 'center',
                  transition: 'all 0.3s ease',
                  ':hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1)'
                  }
                }}>
                  <div style={{ marginBottom: '1.5rem' }}>
                    {industry.icon}
                  </div>
                  <h3 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '1rem' }}>
                    {industry.name}
                  </h3>
                  <p style={{ color: '#475569', lineHeight: 1.6 }}>
                    {industry.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Industries */}
      <div
        className="container-fluid feature-section py-2"
        style={{ background: 'linear-gradient(135deg, #024A59 0%, #FFA916 100%)' }}
      >
        <div className="container">
          <div className="text-center mb-2">
            <h2 className="section-title">Industries We Serve</h2>
          </div>
          <div className="row g-4">
            {[
              { title: "Healthcare", icon: Stethoscope },
              { title: "Finance", icon: Banknote },
              { title: "Manufacturing", icon: Factory },
              { title: "Supply Chain", icon: Boxes },
              { title: "Human Resource", icon: Users },
              { title: "Education", icon: BookOpen },
              { title: "NGO", icon: HeartHandshake },
              { title: "Tours & Travel", icon: Plane }
            ].map((feature, index) => (
              <div key={index} className="col-lg-3 col-md-6 d-flex">
                <div className="feature-card w-100 text-center">
                  <div className="feature-icon">
                    <feature.icon className="icon" />
                  </div>
                  <h5 className="feature-title">{feature.title}</h5>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Why Choose Us */}
      <WhyChooseUs />

      <style jsx global>{`
        @keyframes slideIn {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
          .section-title {
           font-size: 2.5rem;
           font-weight: 700;
           margin-bottom: 1rem;
           position: relative;
           display: inline-block;
         } 
          
           @keyframes fadeIn {
             from { opacity: 0; transform: translateY(20px); }
             to { opacity: 1; transform: translateY(0); }
           }

           @keyframes bounce {
             0%, 100% { transform: translateY(0); }
             50% { transform: translateY(-10px); }
           }
        

         .section-title.text-gradient {
           background: linear-gradient(45deg, #024A59, #FFA916);
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
         }

.product-card {
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.05);
  text-align: center;
  transition: transform 0.3s ease;
}

.product-card:hover {
  transform: translateY(-5px);
}

.product-img-wrapper {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.product-img {
  max-height: 100%;
  width: auto;
  object-fit: contain;
}

         .f/* Section background + title */
.feature-section {
  background: #f1f5f9;           /* light grey */
}
.feature-section .section-title {
  color: #024A59;                /* dark teal */
  font-weight: 700;
}

/* Card styling */
.feature-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
}

/* Icon styling */
.feature-icon .icon {
  font-size: 2rem;
  color: #FFA916;
  margin-bottom: 0.75rem;
}

/* Title styling */
.feature-title {
  color: #024A59;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}


         @media (max-width: 768px) {
           .section-title {
             font-size: 2rem;
           }
         product-card {
          background: white;
          border-radius: 15px;
          padding: 0.5rem;
          margin-bottom: 1rem;
          transition: all 0.3s ease;
          box-shadow: 0 10px 30px rgba(0,0,0,0.08);
        }

        .product-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
        }

        .icon-box {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          transition: all 0.3s ease;
        }

        .feature-section {
          background: linear-gradient(45deg, #024A59, #FFA916);
          color: white;
          position: relative;
          overflow: hidden;
        }

        .feature-card {
          background: rgba(255,255,255,0.1);
          padding: 0.2rem;
          border-radius: 5px;
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }


      `}</style>
    </div>
  );
};

export default ProductsPage;
